module.exports = __webpack_public_path__ + "static/media/goals-and-targets-market-share.3b3f5c78.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/goals-and-targets-market-share.mp4
// module id = 560
// module chunks = 0